import React from 'react';
import T from 'mrf/utils/T';

export default function Status404NotFound() {
    const url = window.location.href;
    return <div><T values={{ url }}>[404] Page not found: {'{{url}}'}</T></div>;
}
